import { Component, OnInit, ViewChild, Output, EventEmitter, HostListener } from '@angular/core';
import { HasPermissions, Permissions } from '../../../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../../../core/services/permissions/permissions.service';
import { ModalComponent } from '../../../../../core/shared/modal/modal.component';
import { NgForm } from '@angular/forms';
import { CustomersRest } from '../../../customers.rest';
import { License, Customer } from '../../../customers.model';
import { DateInputModel } from '../../../../../core/shared/date-input/date-input.model';

const startDateInternalName = 'startDate';
const expirationDateInternalName = 'expirationDate';

@Component({
  selector: 'app-license-modal',
  templateUrl: './license-modal.component.html'
})
export class LicenseModalComponent implements OnInit, HasPermissions {

  permissions: Permissions;
  public license: License;
  public customer: Customer;
  public expirationDate: DateInputModel;
  public startDate: DateInputModel;
  public enabled: boolean = true;
  private isNew: boolean;
  private isSaving = false;

  @ViewChild(ModalComponent) public modal: ModalComponent;
  @ViewChild('licenseForm') licenseForm: NgForm;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.modal.modalRoot.isShown === true && this.licenseForm.valid) {
      this.saveLicense();
      event.preventDefault();
    }
  }

  constructor(private permissionService: PermissionsService,
    private rest: CustomersRest) { }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  ngOnInit() {
    this.setPermissions('Customer');
  }

  public open(isNew: boolean, license: License, customer: Customer) {
    this.customer = customer;
    this.isNew = isNew;
    if (this.isNew || !license) {
      this.license = new License();
      this.license.startDate = new Date();
      this.license.expirationDate = new Date();
      this.license.checkFrequency = 0;
    }
    else{
      this.license = license
    }
    this.setupDates(this.license);
    this.modal.openWithCustomSize({ width: '650px' });
  }

  public closeModal() {
    this.modal.close();
  }

  public saveLicense() {
    if (this.isSaving) {
      return;
    }
    this.license.customerId = this.customer.id;
    this.selectedDates();
    this.isSaving = true;
    const action = this.rest.saveLicense;
    action.call(this.rest, this.license).subscribe((license: License) => {
      const emmitData = { isSuccess: true, isNew: this.isNew, license: license };
      this.isSaving = false;
      this.modal.close();
      this.onSuccess.emit(emmitData);
    });
  }

  public onDateValidation(date: DateInputModel, isValid: boolean) {
    if (!date) {
      return;
    }
    if (date.internalName === startDateInternalName && this.startDate.value > this.expirationDate.value) {
      this.expirationDate.value = new Date(date.value);
      this.expirationDate.value.setHours(2, 0, 0, 0);
      this.expirationDate.valueStr = this.expirationDate.value.toDateString();
      this.startDate.value.setHours(2, 0, 0, 0);
    }
    if (date.internalName === expirationDateInternalName && date.value < this.startDate.value) {
      if (date.value != null) {
        this.startDate.value = new Date(date.value);
        this.startDate.value.setHours(2, 0, 0, 0);
        this.startDate.valueStr = this.startDate.value.toDateString();
        this.expirationDate.value.setHours(2, 0, 0, 0);
      }
    }
  }

  public setupDates(license: License) {
    this.setupExpirationDate(new Date(license.expirationDate));
    this.setupStartDate(new Date(license.startDate));
  }

  public onCheckFrequencyChanged(value){
    this.license.checkFrequency = value;
  }

  private setupExpirationDate(expirationDate: Date | string) {
    if(typeof(expirationDate) === 'string'){
      expirationDate = new Date(expirationDate)
    }
    this.expirationDate = new DateInputModel();
    this.expirationDate.isReadOnly = !this.enabled;
    this.expirationDate.isRequired = true;
    this.expirationDate.name = 'Data wygaśnięcia licencji:';
    this.expirationDate.value = expirationDate;
    this.expirationDate.value.setHours(2, 0, 0, 0);
    this.expirationDate.internalName = expirationDateInternalName;

    this.expirationDate.valueStr = this.expirationDate.value.toDateString();
    this.expirationDate.withTime = false;
  }

  private setupStartDate(startDate: Date | string) {
    if(typeof(startDate) === 'string'){
      startDate = new Date(startDate)
    }
    this.startDate = new DateInputModel();
    this.startDate.isReadOnly = !this.enabled;
    this.startDate.isRequired = true;
    this.startDate.name = 'Data początkowa:';
    this.startDate.value = startDate;
    this.startDate.value.setHours(2, 0, 0, 0);
    this.startDate.internalName = startDateInternalName;

    this.startDate.valueStr = this.expirationDate.value.toDateString();
    this.startDate.withTime = false;
  }

  private selectedDates() {
    if (this.startDate.value != null) {
      this.license.startDate = this.startDate.value;
    }
  
    if (this.expirationDate.value != null) {
      this.license.expirationDate = this.expirationDate.value;
    }
  }
}
